import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Import all your components
import "./AdminDashboard/css/Sidebar.css";
import Sidebar from "./AdminDashboard/Sidebar";
import DashboardPage from "./AdminDashboard/dashboard";
import Topbar from "./AdminDashboard/Topbar";
import SellerManagement from "./AdminDashboard/sellermanagement/SellerManagement";
import SellerStoreInformation from "./AdminDashboard/sellerstore/SellerStoreInformation";
import ProductList from "./AdminDashboard/productlist/Productlist";
import ProductManagement from "./AdminDashboard/productmanagement/Productmanagement";
import Usermanagement from "./AdminDashboard/usermanagement/Usermanagement";
import Userview from "./AdminDashboard/usermanagement/Userview";
import ReviewList from "./AdminDashboard/reviewuser/Reviewuser";
import OrderManagement from "./AdminDashboard/orderpage/OrderMnagement";
import BlogManagement from "./AdminDashboard/blogmanagement/Blogmanagement";
import Category from "./AdminDashboard/categorypage/Category";
import Notification from "./AdminDashboard/Notificationpage/Notification";
import Sensor from "./AdminDashboard/Sensorpage/Sensor";
import Setting from "./AdminDashboard/Settingpage/SettingAdmin";
import AboutUs from "./AdminDashboard/AboutUspage/AboutUs";
import Login from "./AdminDashboard/Adminloginpage/AdminLogin";
import Createaccount from "./AdminDashboard/createaccount/Createaccount";
import OTPVerification from "./AdminDashboard/otp-verify/Otpverify";
import Signin from "./AdminDashboard/signin/Signin";
import SellerDetails from "./AdminDashboard/sellermanagement/sellerDetails";
import WishlistPage from "./AdminDashboard/wishlist/Wishlist";
import NewsletterPage from "./AdminDashboard/newslettermanagement/Newslettermanagement";
import EnquiryPage from "./AdminDashboard/enquirymanagement/Enquirymanagement";
import AdminManagement from "./AdminDashboard/adminmanagement/Adminmanagement";
import AdminDetailsPage from "./AdminDashboard/adminmanagement/Admindetailspage";
import AdminProfilePage from "./AdminDashboard/adminprofile/Adminprofile";
import EmployeeManagement from "./AdminDashboard/employeemanagement/Employeemanagement";
import EmployeeDetailsPage from "./AdminDashboard/employeemanagement/Employeedetailspage";
import Cart from "./AdminDashboard/Cart/Cart";
import SoilTestingPage from "./AdminDashboard/Soil/Soil";
import Dronemangement from "./AdminDashboard/Dronemanagement/Drone";
import DroneService from "./AdminDashboard/Dronebooking/Dronebooking";
import FarmPrecisionPage from "./AdminDashboard/farmprecision/Farmprecision";
import Blogmenagementupdate from "./AdminDashboard/blogmanagement/Blogmenagementupdate";
import Blogmanagementcreate from "./AdminDashboard/blogmanagement/Blogmanagementcreate";
import Createproduct from "./AdminDashboard/productmanagement/Createproduct";
import SubscriptionManagementPage from "./AdminDashboard/subscriptionManagement/Subscription";

import "../src/App.css";
import "../src/styles/variable.css";
import RoleManagement from "./AdminDashboard/Rolemanagement/Fecth-Role";
import Createrole from "./AdminDashboard/Rolemanagement/Createrole";
import Editrolepage from "./AdminDashboard/Rolemanagement/Edit-Role";
import Revenuemanagement from "./AdminDashboard/revenue/Revenuemanagement";
import Enquiryservice from "./AdminDashboard/EnquiryService/EnquiryService";

function App() {
  const navigate = useNavigate();
  const [loggedInAdminName, setLoggedInAdminName] = useState("Guest");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };

  const getAdminNameFromInfo = (adminInfo) => {
    if (adminInfo.name) {
      return adminInfo.name;
    } else if (adminInfo.username) {
      return adminInfo.username;
    } else if (adminInfo.fullName) {
      return adminInfo.fullName;
    } else if (adminInfo.firstName && adminInfo.lastName) {
      return `${adminInfo.firstName} ${adminInfo.lastName}`;
    } else if (adminInfo.email) {
      return adminInfo.email.split("@")[0];
    }
    return "Admin User";
  };

  const handleGlobalAdminNameUpdate = (newAdminName, adminId = null) => {
    console.log("App.js: handleGlobalAdminNameUpdate called with name:", newAdminName, "ID:", adminId);
    setLoggedInAdminName(newAdminName);

    const adminInfoString = localStorage.getItem("adminInfo");
    let adminInfo = {};
    try {
      adminInfo = JSON.parse(adminInfoString || "{}");
    } catch (e) {
      console.error("Error parsing adminInfo from localStorage for global update:", e);
    }

    if (!adminId || (adminInfo._id && adminInfo._id === adminId)) {
      const updatedAdminInfo = { ...adminInfo, name: newAdminName };
      localStorage.setItem("adminInfo", JSON.stringify(updatedAdminInfo));
    }
  };

  useEffect(() => {
    const adminInfoString = localStorage.getItem("adminInfo");

    try {
      const adminInfo = JSON.parse(adminInfoString || "{}");
      if (adminInfo && Object.keys(adminInfo).length > 0) {
        setLoggedInAdminName(getAdminNameFromInfo(adminInfo));
        setIsLoggedIn(true);
      } else {
        setLoggedInAdminName("Guest");
        setIsLoggedIn(false);
      }
    } catch (e) {
      console.error("Error parsing adminInfo from localStorage on App load:", e);
      setLoggedInAdminName("Guest");
      setIsLoggedIn(false);
    }

    const handleStorageChange = (event) => {
      if (event.key === "adminInfo" || event.key === "isLoggedIn" || event.key === null) {
        const newAdminInfoString = localStorage.getItem("adminInfo");
        let newName = "Guest";
        let newLoggedInStatus = localStorage.getItem("isLoggedIn") === "true";

        if (newAdminInfoString) {
          try {
            const newAdminInfo = JSON.parse(newAdminInfoString);
            if (newAdminInfo && Object.keys(newAdminInfo).length > 0) {
              newName = getAdminNameFromInfo(newAdminInfo);
              newLoggedInStatus = true;
            }
          } catch (e) {
            console.error("Error parsing adminInfo on storage event:", e);
          }
        }
        setLoggedInAdminName(newName);
        setIsLoggedIn(newLoggedInStatus);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    navigate("/backoffice/login");
  };

  const renderPageWithLayout = (PageComponent, props = {}) => (
    <>
      <Topbar toggleSidebar={toggleSidebar} adminName={loggedInAdminName} onLogout={handleLogout} />
      <div className="d-flex App01">
        {isLoggedIn && <Sidebar isCollapsed={isSidebarCollapsed} />}
        <div className="page-content">
          <PageComponent
            {...props}
            onAdminNameChange={handleGlobalAdminNameUpdate}
            loggedInAdminId={JSON.parse(localStorage.getItem("adminInfo"))?._id}
          />
        </div>
      </div>
    </>
  );

  return (
    <div className="app-container">
      <ToastContainer position="bottom-right" autoClose={3000} />
      <Routes>
        <Route path="/" element={<Navigate to="/backoffice/login" replace />} />
        <Route path="*" element={<Navigate to="/backoffice/login" replace />} />

        {/* Authentication Routes - These typically do NOT have a sidebar/topbar layout */}
        <Route path="/backoffice/createaccount" element={<Createaccount />} />
        <Route path="/backoffice/Verify" element={<OTPVerification />} />
        <Route path="/backoffice/signin" element={<Signin />} />
        <Route
          path="/backoffice/login"
          element={<Login onAdminNameChange={handleGlobalAdminNameUpdate} setIsLoggedIn={setIsLoggedIn} />}
        />

        {/* Dashboard Route - Uses the common layout helper */}
        <Route path="/backoffice/" element={renderPageWithLayout(DashboardPage)} />

        {/* Other Admin Dashboard Pages - All use the common layout helper */}
        <Route path="/backoffice/sellermanagement" element={renderPageWithLayout(SellerManagement)} />
        <Route path="/backoffice/sellerstore" element={renderPageWithLayout(SellerStoreInformation)} />
        <Route path="/backoffice/rolemanagement" element={renderPageWithLayout(RoleManagement)} />
        <Route path="/backoffice/rolecreate" element={renderPageWithLayout(Createrole)} />
        <Route path="/backoffice/roleupdate/:id" element={renderPageWithLayout(Editrolepage)} />
        <Route path="/backoffice/sellerstore/:id" element={renderPageWithLayout(ProductList)} />
        <Route path="/backoffice/seller-details/:sellerId" element={renderPageWithLayout(SellerDetails)} />
        <Route path="/backoffice/reviewuser/:userId" element={renderPageWithLayout(Userview)} />
        <Route path="/backoffice/cart" element={renderPageWithLayout(Cart)} />
        <Route path="/backoffice/revenue" element={renderPageWithLayout(Revenuemanagement)} />
        <Route path="/backoffice/usermanagement" element={renderPageWithLayout(Usermanagement)} />
        <Route path="/backoffice/reviewuser" element={renderPageWithLayout(ReviewList)} />
        <Route path="/backoffice/dronemanagement" element={renderPageWithLayout(Dronemangement)} />
        <Route path="/backoffice/dronebooking" element={renderPageWithLayout(DroneService)} />
        <Route path="/backoffice/soiltesting" element={renderPageWithLayout(SoilTestingPage)} />
        <Route path="/backoffice/category" element={renderPageWithLayout(Category)} />
        <Route path="/backoffice/order" element={renderPageWithLayout(OrderManagement)} />
        <Route path="/backoffice/Notification" element={renderPageWithLayout(Notification)} />
        <Route path="/backoffice/productmanagement" element={renderPageWithLayout(ProductManagement)} />
        <Route path="/backoffice/createproduct" element={renderPageWithLayout(Createproduct)} />
        <Route path="/backoffice/blogmanagement" element={renderPageWithLayout(BlogManagement)} />
        <Route path="/backoffice/blogmanagementupdate/:id" element={renderPageWithLayout(Blogmenagementupdate)} />
        <Route path="/backoffice/blogcreate" element={renderPageWithLayout(Blogmanagementcreate)} />
        <Route path="/backoffice/Sensor" element={renderPageWithLayout(Sensor)} />
        <Route path="/backoffice/Setting" element={renderPageWithLayout(Setting)} />
        <Route path="/backoffice/AboutUs" element={renderPageWithLayout(AboutUs)} />
        <Route path="/backoffice/wishlist" element={renderPageWithLayout(WishlistPage)} />
        <Route path="/backoffice/newsletter" element={renderPageWithLayout(NewsletterPage)} />
        <Route path="/backoffice/enquirymanagement" element={renderPageWithLayout(EnquiryPage)} />

        {/* Admin Management Pages - These will also receive onAdminNameChange for updates */}
        <Route path="/backoffice/adminmanagement" element={renderPageWithLayout(AdminManagement)} />
        <Route path="/backoffice/profile" element={renderPageWithLayout(AdminProfilePage)} />
        <Route path="/backoffice/admin-details/:adminId" element={renderPageWithLayout(AdminDetailsPage)} />

        {/* Other Pages */}
        <Route path="/backoffice/farmprecision" element={renderPageWithLayout(FarmPrecisionPage)} />
        <Route path="/backoffice/employeemanagement" element={renderPageWithLayout(EmployeeManagement)} />
        <Route path="/backoffice/employee-details/:employeeId" element={renderPageWithLayout(EmployeeDetailsPage)} />

        {/* subscriptions */}
        <Route path="/backoffice/subscription" element={renderPageWithLayout(SubscriptionManagementPage)} />
        <Route path="/backoffice/servicesenquiry" element={renderPageWithLayout(Enquiryservice)} />
      </Routes>
    </div>
  );
}

export default App;